import { AccountType, AppConstants, NumberOfEmployees, PayedBy } from '../../../shared/Constants';
import * as Yup from 'yup';

export const DEFAULT_STATE = {
  activeLocales: [],
  availableNumbersOfEmployees: [],
  account: {
    id: null,
    displayName: null,
    type: null,
    assessmentTemplates: {
      edges: [],
    },
    assessmentSections: {
      behaviorSection: {
        displayName: null,
        dimensions: [],
        distortionDimensions: [],
      },
      cognitiveSection: {
        displayName: null,
        dimensions: [],
      },
      interestsSection: {
        displayName: null,
        dimensions: [],
      },
    },
    surveyTemplates: {
      edges: [],
    },
    surveyCompetencies: [],
  },
};

export const buildInitialValuesForCreateEssentialAccountInvitationForm = (currentAccount, parentAccountType) => {
  return {
    parentId: currentAccount,
    payedBy: parentAccountType === AccountType.GP ? PayedBy.PAYED_BY_SELF : PayedBy.PAYED_BY_PARENT,
    numberOfEmployees: NumberOfEmployees.SELECTED_BY_CLIENT,
    preferredLanguage: AppConstants.DEFAULT_LOCALE,
    email: '',
    fullName: '',
    inviteMessage: '',
    assessmentTemplates: [],
    assessmentDimensions: {
      behaviorDimensions: [],
      distortionDimensions: [],
      cognitiveDimensions: [],
      interestsDimensionsArePresent: false,
    },
    surveyTemplates: [],
    surveyAbilities: [],
  };
};

export const buildValidationSchemaForCreateEssentialAccountInvitationForm = () => {
  return Yup.object().shape({
    preferredLanguage: Yup.string().required(),
    payedBy: Yup.string().required(),
    email: Yup.string()
      .email()
      .required(),
    fullName: Yup.string().required(),
    assessmentTemplates: Yup.array().of(Yup.object()),
    assessmentDimensions: Yup.object()
      .shape({
        behaviorDimensions: Yup.array().default([]),
        distortionDimensions: Yup.array().default([]),
        cognitiveDimensions: Yup.array().default([]),
        interestsDimensionsArePresent: Yup.boolean().default(false),
      })
      .required(),
    surveyTemplates: Yup.array().of(Yup.object()),
    surveyAbilities: Yup.array().of(Yup.object()),
  });
};

export const extractInput = (values, parentId) => {
  const assessmentTemplateIds = values.assessmentTemplates.map(({ node }) => node.id);

  const behaviorDimensions = values.assessmentDimensions.behaviorDimensions.map((d) => d.name);
  const distortionDimensions = values.assessmentDimensions.distortionDimensions.map((d) => d.name);
  const cognitiveDimensions = values.assessmentDimensions.cognitiveDimensions.map((d) => d.name);

  const assessmentDimensions = {
    interestsDimensionsArePresent: values.assessmentDimensions.interestsDimensionsArePresent,
    behaviorDimensions,
    distortionDimensions,
    cognitiveDimensions,
  };

  const surveyAbilities = values.surveyAbilities.map((ability) => ability.id);
  const surveyTemplateIds = values.surveyTemplates.map(({ node }) => node.id);

  return {
    ...values,
    assessmentTemplates: undefined,
    assessmentTemplateIds,
    assessmentDimensions,
    surveyTemplates: undefined,
    surveyTemplateIds,
    surveyAbilities,
    parentId,
  };
};
